import { grey } from '@material-ui/core/colors'
import { BORAL_GREEN } from 'Constants/Theme/Theme.constants'
import Colors from 'Support/Theme/Colors/Colors'

const ProgressDoneStyle = ({ theme }: { theme: any}) => ({
  modalWrapper: {
    minWidth: '360px',
  },
  topWrapper: {
    padding: '76px 20px 24px',
  },
  topWrapperDone: {
    paddingTop: '24px',
  },
  checkIcon: {
    fontSize: '60px',
  },
  waitingText: {
    margin: '24px 0',
  },
  submittedText: {
    marginTop: '24px',
  },
  nextStepsTitle: {
    paddingTop: '30px',
  },
})

export default ProgressDoneStyle
